import { render, staticRenderFns } from "./PurchaseAnalysis.vue?vue&type=template&id=d1a1b870"
import script from "./PurchaseAnalysis.vue?vue&type=script&lang=ts"
export * from "./PurchaseAnalysis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports